module.exports = __webpack_public_path__ + "static/media/quotes-fc.e6e9d0ad.svg";